import { AlertCircle } from "lucide-react";
import Loading from "../../shared/Loading";

const ReassignPrompt = ({
  closeReassignPrompt,
  handleAcceptPrompt,
  reassignDetails,
  loading,
}) => {
  return (
    <div
      onClick={(e) => {
        closeReassignPrompt();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] p-[20px] relative bg-white"
      >
        <AlertCircle color="#F4A261" />
        <p className="text-[#5C5C5C] text-[16px] text-center font-semibold">
          Are you sure you want to reassign this loan from{" "}
          {reassignDetails?.currentOfficer} to {reassignDetails?.newOfficerName}
          ? This will update the loan record immediately.
        </p>
        <div className="flex items-center justify-center gap-[10px]">
          <button
            onClick={closeReassignPrompt}
            className="h-[35px] rounded-[30px] bg-[#F3F3F3] px-[20px] text-[#5C5C5C] font-medium text-[15px]"
          >
            Close
          </button>
          <button
            disabled={loading}
            onClick={handleAcceptPrompt}
            className="h-[35px] flex items-center justify-center gap-[5px] rounded-[30px] bg-[#000000] px-[20px] text-[#F3F3F3] font-medium text-[15px]"
          >
            {loading && <Loading />}
            Yes, Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReassignPrompt;
